import React from 'react';
import { StyleSheet, View } from 'react-native';

const Stepper = (props: {
  currentStage: number;
  totalStages: number;
  customStyle?: ViewStyleProp;
}) => {
  const { currentStage, totalStages, customStyle } = props;
  const rows = [];

  for (let i = 0; i < totalStages; i++) {
    rows.push(
      <View
        key={`multistage-${i}`}
        // {...testID(`multistage-${i}`)}
        style={{
          flex: 1,
          height: 4,
          marginRight: i === totalStages - 1 ? 0 : 16,
          backgroundColor: i === currentStage - 1 ? '#E30E80' : '#e1e1e1',
          borderRadius: 16,
        }}
      />
    );
  }

  return <View style={[styles.container, customStyle]}>{rows}</View>;
};

const styles = StyleSheet.create({
  container: {
    marginTop: 26,
    marginBottom: 10,
    flexDirection: 'row',
    paddingHorizontal: 0,
  },
});

export default Stepper;
